import { QueueItemType } from "../store/supervisor-home-types";

// The overview endpoint is read-only: every row and section link hands the
// supervisor off to the page that actually owns the approve/deny/assign action.
export const HOME_LINKS = {
	flexSchedule: "/flex-schedule",
	flexShiftRequests: "/worker-requests-flex",
	timeOffRequests: "/worker-requests",
	team: "/manage-workers",
	evaluations: "/evaluations",
	fullTimeSchedule: "/full-time-schedule",
} as const;

export function getQueueItemUrl(type: QueueItemType): string {
	switch (type) {
		case "shiftSwap":
			return HOME_LINKS.flexShiftRequests;
		case "timeOff":
			return HOME_LINKS.timeOffRequests;
		case "openShift":
		default:
			return HOME_LINKS.flexSchedule;
	}
}
